/* atomera theme — progressive enhancement only.
   Everything degrades to working HTML forms and links if JS fails. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- header */

  function initHeader() {
    var wrap = document.querySelector('[data-header]');
    if (!wrap) return;

    var onScroll = function () {
      wrap.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var toggle = document.querySelector('[data-nav-toggle]');
    var panel = document.querySelector('[data-mobile-nav]');
    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var open = panel.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* --------------------------------------------------------- product media */

  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      if (!main || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var srcset = thumb.getAttribute('data-srcset');
          var alt = thumb.getAttribute('data-alt') || '';
          if (!src) return;
          main.setAttribute('src', src);
          if (srcset) main.setAttribute('srcset', srcset);
          main.setAttribute('alt', alt);
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* -------------------------------------------------------- variant picker */

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var value = parts.join('.');
    return (format || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, value);
  }

  function initVariants() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var form = document.querySelector('[data-product-form="' + picker.getAttribute('data-variant-picker') + '"]');
      if (!form) return;

      var idInput = form.querySelector('input[name="id"]');
      var submit = form.querySelector('[data-add-button]');
      var priceEl = document.querySelector('[data-price-current]');
      var compareEl = document.querySelector('[data-price-compare]');
      var unitEl = document.querySelector('[data-price-unit]');
      var moneyFormat = picker.getAttribute('data-money-format') || '${{amount}}';

      var apply = function (input) {
        if (!input) return;
        if (idInput) idInput.value = input.value;

        var available = input.getAttribute('data-available') === 'true';
        if (submit) {
          submit.disabled = !available;
          submit.textContent = available
            ? submit.getAttribute('data-label-default')
            : submit.getAttribute('data-label-sold-out');
        }

        if (priceEl) {
          priceEl.textContent = formatMoney(parseInt(input.getAttribute('data-price'), 10), moneyFormat);
        }
        if (compareEl) {
          var compare = parseInt(input.getAttribute('data-compare-price'), 10);
          var price = parseInt(input.getAttribute('data-price'), 10);
          if (compare && compare > price) {
            compareEl.textContent = formatMoney(compare, moneyFormat);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (unitEl) {
          unitEl.textContent = input.getAttribute('data-unit-note') || '';
        }

        // Keep the URL shareable without reloading.
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', input.value);
          window.history.replaceState({}, '', url.toString());
        }
      };

      picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.addEventListener('change', function () { apply(input); });
      });

      apply(picker.querySelector('input[type="radio"]:checked'));
    });
  }

  /* ------------------------------------------------------------ sticky atc */

  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { rootMargin: '0px 0px -10% 0px' });

    observer.observe(anchor);

    // Mirror the selected variant into the sticky form.
    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-variant-picker] input[type="radio"]')) return;
      var stickyId = bar.querySelector('input[name="id"]');
      if (stickyId) stickyId.value = event.target.value;
      var stickyPrice = bar.querySelector('[data-sticky-price]');
      if (stickyPrice) {
        var main = document.querySelector('[data-price-current]');
        if (main) stickyPrice.textContent = main.textContent;
      }
    });
  }

  /* ----------------------------------------------------------------- cart */

  function initCart() {
    document.querySelectorAll('[data-cart-remove]').forEach(function (button) {
      button.addEventListener('click', function () {
        var form = button.closest('form');
        var input = form && form.querySelector('[data-cart-qty="' + button.getAttribute('data-cart-remove') + '"]');
        if (!input || !form) return;
        input.value = 0;
        form.submit();
      });
    });

    document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (form) form.submit();
      });
    });
  }

  /* ------------------------------------------------------- marquee cloning */

  function initMarquee() {
    document.querySelectorAll('[data-marquee-track]').forEach(function (track) {
      if (track.getAttribute('data-cloned') === 'true') return;
      track.innerHTML += track.innerHTML;
      track.setAttribute('data-cloned', 'true');
    });
  }

  /* ---------------------------------------------------------------- boot */

  function boot() {
    initHeader();
    initGallery();
    initVariants();
    initStickyAtc();
    initCart();
    initMarquee();
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Re-run after Shopify theme editor re-renders a section.
  document.addEventListener('shopify:section:load', boot);
})();